<template>
<billing-dialog v-model="visible" aria-labelledby="pbx-plan-detail-id" class="pbx-detail-dialog" show-close @close="handleCancel" width="510px" :before-close="trackingClose" @back-event="visible = false">
  <span id="pbx-plan-detail-id" class="opc_hidden_element">Zoom Phone dialog</span>
  <!--header-->
  <img :src="logo" alt="" class="pbx-detail-dialog__logo">
  <h2 class="pbx-detail-dialog__title">{{ callingPlanName }}</h2>
  <div class="pbx-detail-dialog__price">
    <div class="pbx-detail-dialog__price-content">
      <div v-if="isFreeTrialFlow" class="pbx-detail-dialog__trial-badge">
        {{ $t('billing.pbx.free_trial.x_day_trial_desc', [freeTrialDays]) }}
      </div>
      <Price class="pbx-detail-dialog__price-item" :currency="currencySymbol" :price="monthlyPrice" :unit="$t('billing.common.per_billing_cycle_user.monthly')" />
    </div>
    <div class="pbx-detail-dialog__price-content">
      <div v-if="isFreeTrialFlow" class="pbx-detail-dialog__trial-badge" style="visibility: hidden;">
        {{ $t('billing.pbx.free_trial.x_day_trial_desc', [freeTrialDays]) }}
      </div>
      <Price class="pbx-detail-dialog__price-item" :currency="currencySymbol" :price="annualPrice" :unit="$t('billing.common.per_billing_cycle_user.annual')" />
    </div>
  </div>
  <FeatureULForUnlimited :isFreeTrialFlow="isFreeTrialFlow" v-if="subType === 'UC'"  />
  <FeatureULForMetered v-else />
  <zm-button v-if="!isFreeTrialFlow" data-testid="checkout-button-179" type="text" @click="handleSure">{{ $t('billing.pbx.plan_details.view_more') }}</zm-button>
</billing-dialog>
</template>

<script lang="jsx">
import ZoomPhoneIcon from '@/assets/plans/logo_zoom_phone.svg';
import Price from '@/components/price.vue';
import { ConfirmComponent } from '@/components/common/service-dialog/confirm';
import EssentialAppLearnMoreDialog from '@/components/app-bundle-learn-more-dialog.vue';
import { mapState } from 'vuex';
import { BILLING_CYCLE } from '@/common/constants';
import { ServiceConfirm } from '@/components/common/service-dialog/confirm';
import {getCurrency, getCurrencySymbol} from "@/utils/currency";
import { computedPbxCallingPlans, PBX_SUB_TYPES } from '@/common/service/computers/plans/pbx';
import BillingDialog from '@/components/billing-dialog.vue';

const FeatureULForUnlimited = {
  props: {
    isFreeTrialFlow: {
      type: Boolean,
      default: false,
    },
  },
  render() {
    return (
      <ul class="pbx-detail-dialog__feature" aria-label="Unlimited Calling Plan feature list">
        <li class="pbx-detail-dialog__feature-item">{ this.$t('marketing.new_pricing.phone.unlimited_plan.item2') }</li>
        <li class="pbx-detail-dialog__feature-item">{ this.$t('marketing.new_pricing.phone.metered_plan.item1') }</li>
        <li class="pbx-detail-dialog__feature-item">
          {this.$t('marketing.new_pricing.phone.item.sms')}
          <zm-tooltip
            placement="top"
            content={this.$t('marketing.new_pricing.phone.item.sms.tip')}
          >
            <tips-icon data-testid="checkout-button-180" aria-label="domestic SMS & MMS" />
          </zm-tooltip>
        </li>
        <li class="pbx-detail-dialog__feature-item">{this.$t('marketing.new_pricing.phone.metered_plan.item3')}</li>
        <li class="pbx-detail-dialog__feature-item">{this.$t('marketing.new_pricing.common.one_management_portal')}
          <zm-tooltip
            placement="top"
            content={this.$t('marketing.new_pricing.common.one_management_portal_tooltip')}
          >
            <tips-icon data-testid="checkout-button-181" aria-label="one management portal" />
          </zm-tooltip>
        </li>
        {!this.isFreeTrialFlow && (<li class="pbx-detail-dialog__feature-item">{this.$t('marketing.new_pricing.phone.domestic_plan.item5')}
          <zm-tooltip
            placement="top"
            content={this.$t('marketing.new_pricing.phone.domestic_plan.item5.tip')}
          >
            <tips-icon data-testid="checkout-button-182" aria-label="countries/territory" />
          </zm-tooltip>
        </li>
        )}
      </ul>
    );
  },
};

const FeatureULForMetered = {
  render() {
    return (
      <ul class="pbx-detail-dialog__feature" aria-label="Metered Calling Plan feature list">
        <li class="pbx-detail-dialog__feature-item" innerHTML={this.$t('marketing.new_pricing.phone.metered_plan.new.item1')} />
        <li class="pbx-detail-dialog__feature-item">{this.$t('marketing.new_pricing.phone.metered_plan.item1')}</li>
        <li class="pbx-detail-dialog__feature-item">
          {this.$t('marketing.new_pricing.phone.item.sms')}
          <zm-tooltip
            placement="top"
            content={this.$t('marketing.new_pricing.phone.item.sms.tip')}
          >
            <tips-icon data-testid="checkout-button-183" aria-label="domestic SMS & MMS" />
          </zm-tooltip>
        </li>
        <li class="pbx-detail-dialog__feature-item">{this.$t('marketing.new_pricing.phone.metered_plan.item3')}</li>
        <li class="pbx-detail-dialog__feature-item">{this.$t('marketing.new_pricing.common.one_management_portal')}

          <zm-tooltip
            placement="top"
            content={this.$t('marketing.new_pricing.common.one_management_portal_tooltip')}
          >
            <tips-icon data-testid="checkout-button-184" aria-label="one management portal" />
          </zm-tooltip>
        </li>
      </ul>
    )
  },
}

export default {
  name: 'CallingPlanDetails',
  mixins: [ConfirmComponent],
  components: {
    Price,
    FeatureULForUnlimited,
    FeatureULForMetered,
    BillingDialog,
  },
  props: {
    subType: String,
    trialDays: {
      type: Number,
      default: 14,
    },
  },
  data() {
    return {
      visible: false,
      logo: ZoomPhoneIcon,
      currencySymbol: getCurrencySymbol(getCurrency()),
      essentialAppLearnMoreDialogService: new ServiceConfirm(EssentialAppLearnMoreDialog, this.$store),
      videoSrc: 'https://static-st2.zoomdev.us/fe-static/billing-web/media/phone.c429f749.mp4',
      videoPoster: 'https://static-st2.zoomdev.us/fe-static/billing-web/img/pbx_video_bg.f0e37265.png',
    };
  },
  methods: {
    handleOpen() {
      this.$tracking.buyInteraction('product details', `zoom phone plan details - ${this.typeName} - impression`);
    },
    handleSure() {
      this.$tracking.buyInteraction('product details', `zoom phone plan details - ${this.typeName} - view more`);
    },
    trackingClose(close) {
      this.$tracking.buyInteraction('product details', `zoom phone plan details - ${this.typeName} - exit`);
      close();
    }
  },
  computed: {
    ...mapState({
      planMapFlat: (state) => state.ShoppingCart.planMapFlat,
    }),
    annualPriceNum () {
      let annualPlan = computedPbxCallingPlans(this.planMapFlat).find(plan => (
        plan.sub_type === this.subType &&
        plan.billing_cycle === BILLING_CYCLE.ANNUAL
      ));
      if (annualPlan) {
        return annualPlan.amount;
      }
      return 0;
    },
    annualPrice () {
      return this.$money(this.annualPriceNum);
    },
    monthlyPriceNum () {
      let monthlyPlan = computedPbxCallingPlans(this.planMapFlat).find(plan => (
        plan.sub_type === this.subType &&
        plan.billing_cycle === BILLING_CYCLE.MONTHLY
      ));
      if (monthlyPlan) {
        return monthlyPlan.amount;
      }
      return 0;
    },
    monthlyPrice () {
      return this.$money(this.monthlyPriceNum);
    },
    callingPlanName() {
      switch(this.subType) {
        case PBX_SUB_TYPES.UNLIMITED:
          return this.$t('billing.pbx.detail_dialog.unlimited.plan_name');
        case PBX_SUB_TYPES.METERED:
          return this.$t('billing.pbx.detail_dialog.metered.plan_name');
        default:
          return '';
      }
    },
    typeName() {
      return this.subType === PBX_SUB_TYPES.METERED ? 'metered' : 'unlimited regional';
    },
    isFreeTrialFlow() {
      return this.$context.is.buyTrial || this.$context.is.add2trial;
    },
    freeTrialDays() {
      // Use trialDays prop, default to 14
      return this.trialDays;
    }
  },
}
</script>

<style lang="scss">
@import '@/styles/_variables.scss';
@import '@zoom/billing-responsive/styles/responsive.scss';

.pbx-detail-dialog {
  &__logo {
    width: 91px;
    height: 16px;
    object-fit: contain;
    margin-bottom: 4px;
  }
  &__title {
    font-style: normal;
    font-weight: 600;
    font-size: 20px;
    line-height: 120%;
    color: var(--zoom-color-text-neutral, #2A2B2D);
    margin-bottom: 16px;
  }
  &__trial-badge {
    display: inline-block;
    padding: 4px 8px;
    margin-bottom: 8px;
    border-radius: 100px;
    background: linear-gradient(93deg, #268543 7.27%, #1C837E 92.73%);
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
    text-transform: uppercase;
    color: #FFF;
    text-align: center;
    margin-right: 24px;
  }

  &__price {
    width: 100%;
    display: flex;
    flex-direction: row;
    margin-bottom: 17px;

    &-content {
      flex: 1;
      display: flex;
      flex-direction: column;

      & + & {
        padding-left: 24px;
        border-left: 2px solid #B8B8C4;
      }
    }

    &-item {
      flex: 1;
      padding-right: 24px;
      padding-left: 0;
      display: flex;
      align-items: flex-start;
      .price__currency {
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        line-height: 36px;
        color: var(--zoom-color-text-stronger-neutral, #2A2B2D);
        margin-right: 2px;
      }
      .price__int {
        font-style: normal;
        font-weight: 400;
        font-size: 32px;
        line-height: 48px;
        color: var(--zoom-color-text-stronger-neutral, #2A2B2D);
        margin-right: 2px;
      }
      .price__decimal {
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        line-height: 36px;
        color: var(--zoom-color-text-stronger-neutral, #2A2B2D);
        margin-right: 2px;
      }
      .price__unit {
        font-style: normal;
        font-weight: 450;
        font-size: 16px;
        line-height: 38px;
        color: var(--zoom-color-text-stronger-neutral, #2A2B2D);
        align-self: flex-end;
      }
      &+& {
        padding-right: 0;
        padding-left: 24px;
        border-left: 2px solid var(--zoom-color-border-subtle-neutral, #DFE3E8);
      }
    }
  }
  &__feature {
    &-title {
      font-style: normal;
      font-weight: 600;
      font-size: 14px;
      line-height: 150%;
      color: var(--zoom-color-text-stronger-neutral, #2A2B2D);
    }
    &-item {
      position: relative;
      padding-left: 20px;
      margin-bottom: 16px;
      font-style: normal;
      font-weight: 500;
      font-size: 14px;
      line-height: 150%;
      color: var(--zoom-color-text-stronger-neutral, #2A2B2D);
      &::before {
        position: absolute;
        top: 0;
        left: 0;
        content: "";
        background-image: url('../../../../assets/Vector.svg');
        background-repeat: no-repeat;
        background-size: cover;
        width: 16px;
        height: 21px;
        font-size: 20px;
        font-weight: 700;
      }
    }
  }
  &__video {
    width: 100%;
    max-width: 100%;
    border-radius: 15px;
    opacity: 0.6;
    outline: none;
  }
  &__tips {
    margin: 0;
    margin-top: 16px;
    padding: 8px 12px;
    background: var(--zoom-color-bg-neutral, #FCFDFD);
    border-radius: 8px;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 150%;
    color: #515079;
  }
}
</style>
